/** @format */

import { dust } from './dustRequest';

export function sendDustLog(url, parameter) {
  return dust({
    url,
    method: 'post',
    data: parameter,
  });
}
